import VueI18n from 'vue-i18n';

/**
 * DateTime format configurations for Danish locale
 * Usage examples:
 * $d(new Date(), 'short')    // "15. mar. 2024"
 * $d(new Date(), 'long')     // "fredag den 15. marts 2024"
 * $d(new Date(), 'time')     // "14:30"
 * $d(new Date(), 'dateTime') // "15. marts 2024 kl. 14:30"
 */
const dateTimeFormats: VueI18n.DateTimeFormats = {
  da: {
    // Short format: "15. mar. 2024"
    short: {
      year: 'numeric' as const, // 2024
      month: 'short' as const, // mar.
      day: 'numeric' as const, // 15
    },
    // Long format: "fredag den 15. marts 2024"
    long: {
      year: 'numeric' as const, // 2024
      month: 'long' as const, // marts
      day: 'numeric' as const, // 15
      weekday: 'long' as const, // fredag
    },
    // Time format: "14:30"
    time: {
      hour: '2-digit' as const, // 14
      minute: '2-digit' as const, // 30
    },
    // DateTime format: "15. marts 2024 kl. 14:30"
    dateTime: {
      year: 'numeric' as const, // 2024
      month: 'long' as const, // marts
      day: 'numeric' as const, // 15
      hour: '2-digit' as const, // 14
      minute: '2-digit' as const, // 30
    },
  },
};

export default dateTimeFormats;
